import React, { useContext } from 'react'
import { useLayoutHeader } from 'components/MainLayout'
import "./StartRide.css"
import { Route, Switch, useHistory, useRouteMatch, Redirect } from "react-router";
import TypingView from "./Typing";
import QrScannerContainer from "./QrScanner"
import routesConfig from "../../routesConfig";
import CameraAccessView from "./CameraAccess";
import { message } from "antd";
import { getRideApi } from "../../api";
import { connect } from 'react-redux';
import { selectCameraPermissionAsked } from 'store/app/reducer';
import { fixNumbers } from 'utils';
import { GeolocationContext } from 'components/GeolocationContext';
import { rideStarted } from 'store/ride/actions';


const headerConfig = {
    pageTitle: "سفر",
    closeable: true,
    menuEnabled: false,
    extra: [],
    customClass: 'background-indigo',
}

function StartRideView({ cameraPermissionAsked, dispatch }) {
    const { path } = useRouteMatch();
    const history = useHistory()
    useLayoutHeader(headerConfig)
    // test location
    // const coords = { latitude: 35.71301702262063, longitude: 51.405303402140746 }
    const { coords } = useContext(GeolocationContext)
    const startRideReq = ({ scanCode }) => {
        if (coords && coords.latitude && coords.longitude) {
            getRideApi().startRide({ scanCode: fixNumbers(scanCode), lat: coords.latitude, lon: coords.longitude })
                .then(() => { 
                    dispatch(rideStarted())
                    history.push(routesConfig.home) 
                })
                .catch((error) => {
                    error.json()
                        .then((e) => {
                            if (e.message) {             
                                if ((e.status=='800') && (e.error=='None'))
                                {
                                    message.error('شما یک صورتحساب پرداخت نشده دارید')   
                                    // redirect user to unpaid bill    
                                    history.push(routesConfig.order + '/' + e.message)
                                }
                                else {
                                    if ((e.status=='500') && (e.message == '404 : [no body]'))
                                    {
                                        message.error('این وسیله در حال حاضر قادر به ارائه خدمت نمی‌باشد')
                                    }
                                    else
                                    {
                                        message.error(e.message)  
                                    }  
                                }
                            } else {
                                message.error("خطا در شروع سفر")
                            }
                        })
                        .catch(() => {
                            message.error("خطا در شروع سفر")
                        })
                })
        } else {
            message.error('برای شروع سفر، لازم است موقعیت مکانی شما فعال باشد')
        }
    }
    return <React.Fragment>
        <Switch>
            <Route path={`${path}/typing`}>
                <TypingView startRideReq={startRideReq} />
            </Route>
            <Route path={`${path}/camera-access`}>
                <CameraAccessView />
            </Route>
            <Route path={`${path}/qrcode`}>
                <QrScannerContainer startRideReq={startRideReq} />
            </Route>
            <Route path={`${path}/`}>
                {cameraPermissionAsked ?
                    <Redirect to={`${path}/qrcode`} /> :
                    <Redirect to={`${path}/camera-access`} />
                }
            </Route>
        </Switch>
    </React.Fragment>
}

const mapStateToProps = (state) => ({
    cameraPermissionAsked: selectCameraPermissionAsked(state)
})
export default connect(mapStateToProps)(StartRideView)